// src/components/Doctor/AppointmentModal.jsx
import React from "react";
import {
  Modal,
  Form,
  DatePicker,
  Input,
  Select,
  Button,
  Radio,
  Tabs,
  Typography,
  Tag,
} from "antd";
import dayjs from "dayjs";

const AppointmentModal = ({
  isModalOpen,
  setIsModalOpen,
  modalType,
  handleBookOrReschedule,
  doctorId,
  dispatch,
  fetchDoctorAvailability,
  slotData,
  slotLoading,
  selectedAppointment,
  rescheduleLoading,
}) => {
  return (
    <Modal
      title={
        modalType === "book" ? "Book Appointment" : "Reschedule Appointment"
      }
      open={isModalOpen}
      footer={null}
      onCancel={() => setIsModalOpen(false)}
      width={670}
      style={{ top: 20 }}
      styles={{
        body: { maxHeight: "70vh", overflowY: "auto", paddingRight: "12px" },
      }}
    >
      <Form layout="vertical" onFinish={handleBookOrReschedule}>
        {modalType === "book" && (
          <>
            <Form.Item
              name="patient"
              label="Patient Name"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter patient name" />
            </Form.Item>
            <Form.Item
              name="dob"
              label="Date of Birth"
              rules={[{ required: true }]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              name="gender"
              label="Gender"
              rules={[{ required: true }]}
            >
              <Select placeholder="Select gender">
                <Select.Option value="Male">Male</Select.Option>
                <Select.Option value="Female">Female</Select.Option>
                <Select.Option value="Other">Other</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, type: "email" }]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
            <Form.Item
              name="contact"
              label="Contact"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter contact number" />
            </Form.Item>
          </>
        )}

        <Form.Item
          name="appointmentDate"
          label="Date"
          initialValue={dayjs()}
          rules={[{ required: true }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            disabledDate={(d) => d.isBefore(dayjs().startOf("day"))}
          />
        </Form.Item>

        {modalType === "reschedule" && (
          <>
            <Form.Item
              name="interval"
              label="Select Interval"
              rules={[{ required: true, message: "Please select interval" }]}
            >
              <Radio.Group
                onChange={(e) => {
                  const selectedInterval = e.target.value;
                  dispatch(
                    fetchDoctorAvailability({
                      doctorId,
                      interval: selectedInterval,
                      selectedDate: dayjs().format("YYYY-MM-DD"),
                    })
                  );
                }}
              >
                <Radio value={15}>15 mins</Radio>
                <Radio value={30}>30 mins</Radio>
                <Radio value={60}>60 mins</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name="appointmentTime"
              label="Available Slots"
              rules={[
                { required: true, message: "Please select appointment time" },
              ]}
            >
              {slotLoading ? (
                <Typography.Text>Loading available slots...</Typography.Text>
              ) : slotData ? (
                <Tabs
                  defaultActiveKey="morning"
                  centered
                  items={Object.entries(slotData).map(
                    ([session, { available, booked }]) => ({
                      key: session,
                      label: session.charAt(0).toUpperCase() + session.slice(1),
                      children: (
                        <Form.Item noStyle shouldUpdate>
                          {({ getFieldValue, setFieldsValue }) => {
                            const selectedTime =
                              getFieldValue("appointmentTime");
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {available.map((slot, index) => {
                                  const isBooked = booked.some(
                                    (b) =>
                                      b.start === slot.start &&
                                      b.end === slot.end
                                  );
                                  const value = `${slot.start} - ${slot.end}`;
                                  const isSelected = selectedTime === value;

                                  return (
                                    <Tag.CheckableTag
                                      key={index}
                                      checked={isSelected}
                                      onChange={() => {
                                        if (!isBooked) {
                                          setFieldsValue({
                                            appointmentTime: value,
                                          });
                                        }
                                      }}
                                      style={{
                                        borderRadius: 6,
                                        padding: "6px 14px",
                                        fontSize: 14,
                                        cursor: isBooked
                                          ? "not-allowed"
                                          : "pointer",
                                        border: isSelected
                                          ? "1px solid #1890ff"
                                          : "1px solid #d9d9d9",
                                        backgroundColor: isBooked
                                          ? "#f5f5f5"
                                          : isSelected
                                          ? "#1890ff"
                                          : "#fff",
                                        color: isBooked
                                          ? "#999"
                                          : isSelected
                                          ? "#fff"
                                          : "#1890ff",
                                      }}
                                    >
                                      {slot.start} - {slot.end}
                                    </Tag.CheckableTag>
                                  );
                                })}
                              </div>
                            );
                          }}
                        </Form.Item>
                      ),
                    })
                  )}
                />
              ) : (
                <Typography.Text type="secondary">
                  Select interval to see available slots
                </Typography.Text>
              )}
            </Form.Item>
          </>
        )}

        {modalType === "book" ? (
          <Button type="primary" htmlType="submit" block>
            Book Appointment
          </Button>
        ) : (
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={rescheduleLoading}
          >
            Reschedule Appointment
          </Button>
        )}
      </Form>
    </Modal>
  );
};

export default AppointmentModal;
